import "../ErrorPage/ErrorPage.css";
import { useLocation } from "react-router-dom";

const ErrorPage = () => {
  const location = useLocation();
  const { responseMessage } = location.state || {};

  return (
    <div className="error-container">
      <div className="error-box">
        <div className="error-icon">!</div>
        <h1 className="error-heading">ERROR</h1>
        <p className="error-message">{responseMessage}</p>;
      </div>
    </div>
  );
};

export default ErrorPage;
